import { GET, GET_WARRANTY_FULL_SEARCH } from '../../../../services';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

export const useGetWarrantyFull = ({ handleSubmit }) => {
  const [data, setData] = useState([]);

  const { isPending, mutate: onSearchFull } = useMutation({
    mutationFn: async (searchParamState) => {
      const { search } = searchParamState;
      const response = await GET(
        GET_WARRANTY_FULL_SEARCH({
          search: search || '',
        }),
      );
      return response.result.items || [];
    },
    onSuccess: (response) => {
      const newResult = response.map(r => {
        const remainingDays = r.superMemberStatus ? 'Super Member' : r.remainingDays;
        const expireDate = r.superMemberStatus ? 'Super Member' : r.expireDate;
        return {
          ...r, remainingDays, expireDate
        }
      })
      
      setData(newResult);
    },
  });

  const onFetchFull = () =>
    handleSubmit((values) => {
      return onSearchFull(values);
    })();

  return { dataSource: data, setData, onSearchFull, loading: isPending, onFetchFull };
};
